import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {
	isApiResponseOk,
	normalize,
	normalizedUpdate,
	normalizedDelete,
	truthyWinsMergeStrategy
} from '../../util/utils';

export function controlAttributesReducer(state = initialstate.controlAttributes, action) {
	switch (action.type) {
		case types.CREATE_CONTROL_ATTRIBUTES:
			if (isApiResponseOk(action)) {
				const { response } = action;
				const newAttribute = {
					...response,
					testingTypes: response.attributeTestingTypes
				}
				delete newAttribute.attributeTestingTypes;

				const newState = normalize([newAttribute], 'id', state, truthyWinsMergeStrategy);
				return newState;
			}
			return state;

		case types.GET_CONTROL_ATTRIBUTES:
			if (isApiResponseOk(action) && action.response.data) {
				const newState = normalize(action.response.data, 'attributeId', state, truthyWinsMergeStrategy, true);
				return newState;
			}
			return state;

		case types.UPDATE_CONTROL_ATTRIBUTES:
			if (isApiResponseOk(action)) {
				const { response } = action;
				const newAttribute = {
					...response,
					testingTypes: response.attributeTestingTypes
				}
				delete newAttribute.attributeTestingTypes;

				const newState = normalizedUpdate(newAttribute.attributeId, newAttribute, { ...state });
				return newState;
			}

			return state;
		case types.DELETE_CONTROL_ATTRIBUTES:
			if (isApiResponseOk(action)) {
				const newState = normalizedDelete(state, action.attributeId);
				return newState;
			}
			return state;

		default:
			return state;
	}
}
